export const M_DCM_BASIC_Schema = {
  mapper: {
    /** SP_GetMenu 메뉴 조회 */
    search1: {
      UserId: (context) => context.userInfo?.userid,
    },
  },
};
